module.exports = __webpack_public_path__ + "img/IMG_1699_Foamcore.b796c37b.jpg";